import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.some";
import "core-js/modules/es6.set";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.map";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.string.ends-with";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.set";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.ends-with";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

import prefetchHelper from "./prefetch";
import emitter from "./emitter";
import { setMatchPaths, findPath, findMatchPath as _findMatchPath } from "./find-path";

var preferDefault = function preferDefault(m) {
  return m && m["default"] || m;
};

var stripSurroundingSlashes = function stripSurroundingSlashes(s) {
  s = s[0] === "/" ? s.slice(1) : s;
  s = s.endsWith("/") ? s.slice(0, -1) : s;
  return s;
};

var createPageDataUrl = function createPageDataUrl(path) {
  var fixedPath = path === "/" ? "index" : stripSurroundingSlashes(path);
  return __PATH_PREFIX__ + "/page-data/" + fixedPath + "/page-data.json";
};

var doFetch = function doFetch(url, method) {
  if (method === void 0) {
    method = "GET";
  }

  return new Promise(function (resolve, reject) {
    var req = new XMLHttpRequest();
    req.open(method, url, true);

    req.onreadystatechange = function () {
      if (req.readyState == 4) {
        resolve(req);
      }
    };

    req.send(null);
  });
};

var _loadPageDataJson = function loadPageDataJson(loadObj) {
  var pagePath = loadObj.pagePath,
      _loadObj$retries = loadObj.retries,
      retries = _loadObj$retries === void 0 ? 0 : _loadObj$retries;
  var url = createPageDataUrl(pagePath);
  return doFetch(url).then(function (req) {
    var status = req.status,
        responseText = req.responseText; // Handle 200

    if (status === 200) {
      try {
        var jsonPayload = JSON.parse(responseText);

        if (jsonPayload.path === undefined) {
          throw new Error("not a valid pageData response");
        }

        return Object.assign(loadObj, {
          status: "success",
          payload: jsonPayload
        });
      } catch (err) {// continue regardless of error
      }
    } // Handle 404


    if (status === 404 || status === 200) {
      // If the request was for a 404 page and it doesn't exist, we're done
      if (pagePath === "/404.html") {
        return Object.assign(loadObj, {
          status: "failure"
        });
      } // Need some code here to cache the 404 request. In case
      // multiple loadPageDataJsons result in 404s


      return _loadPageDataJson(Object.assign(loadObj, {
        pagePath: "/404.html",
        notFound: true
      }));
    } // handle 500 response (Unrecoverable)


    if (status === 500) {
      return Object.assign(loadObj, {
        status: "error"
      });
    } // Handle everything else, including status === 0, and 503s. Should retry


    if (retries < 3) {
      return _loadPageDataJson(Object.assign(loadObj, {
        retries: retries + 1
      }));
    } // Retried 3 times already, result is a failure.


    return Object.assign(loadObj, {
      status: "error"
    });
  });
};

var doesConnectionSupportPrefetch = function doesConnectionSupportPrefetch() {
  if ("connection" in navigator && typeof navigator.connection !== "undefined") {
    if ((navigator.connection.effectiveType || "").includes("2g")) {
      return false;
    }

    if (navigator.connection.saveData) {
      return false;
    }
  }

  return true;
};

var toPageResources = function toPageResources(pageData, component) {
  if (component === void 0) {
    component = null;
  }

  var page = {
    componentChunkName: pageData.componentChunkName,
    path: pageData.path,
    webpackCompilationHash: pageData.webpackCompilationHash,
    matchPath: pageData.matchPath
  };
  return {
    component: component,
    json: pageData.result,
    page: page
  };
};

export var BaseLoader =
/*#__PURE__*/
function () {
  function BaseLoader(loadComponent, matchPaths) {
    // Map of pagePath -> Page. Where Page is an object with: {
    //   status: `success` || `error`,
    //   payload: PageResources, // undefined if `error`
    // }
    // PageResources is {
    //   component,
    //   json: pageData.result,
    //   page: {
    //     componentChunkName,
    //     path,
    //     webpackCompilationHash,
    //   }
    // }
    this.pageDb = new Map();
    this.inFlightDb = new Map();
    this.pageDataDb = new Map();
    this.prefetchTriggered = new Set();
    this.prefetchCompleted = new Set();
    this.loadComponent = loadComponent;
    setMatchPaths(matchPaths);
  }

  var _proto = BaseLoader.prototype;

  _proto.setApiRunner = function setApiRunner(apiRunner) {
    this.apiRunner = apiRunner;
    this.prefetchDisabled = apiRunner("disableCorePrefetching").some(function (a) {
      return a;
    });
  };

  _proto.loadPageDataJson = function loadPageDataJson(rawPath) {
    var _this = this;

    var pagePath = findPath(rawPath);

    if (this.pageDataDb.has(pagePath)) {
      return Promise.resolve(this.pageDataDb.get(pagePath));
    }

    return _loadPageDataJson({
      pagePath: pagePath
    }).then(function (pageData) {
      _this.pageDataDb.set(pagePath, pageData);

      return pageData;
    });
  };

  _proto.findMatchPath = function findMatchPath(rawPath) {
    return _findMatchPath(rawPath);
  } // TODO check all uses of this and whether they use undefined for page resources not exist
  ;

  _proto.loadPage = function loadPage(rawPath) {
    var _this2 = this;

    var pagePath = findPath(rawPath);

    if (this.pageDb.has(pagePath)) {
      var page = this.pageDb.get(pagePath);
      return Promise.resolve(page.payload);
    }

    if (this.inFlightDb.has(pagePath)) {
      return this.inFlightDb.get(pagePath);
    }

    var inFlight = Promise.all([this.loadAppData(), this.loadPageDataJson(pagePath)]).then(function (allData) {
      var result = allData[1];

      if (result.status === "error") {
        return {
          status: "error"
        };
      }

      if (result.status === "failure") {
        // throw an error so error trackers can pick this up
        throw new Error("404 page could not be found. Checkout https://www.gatsbyjs.org/docs/add-404-page/");
      }

      var pageData = result.payload;
      var _pageData = pageData,
          componentChunkName = _pageData.componentChunkName;
      return _this2.loadComponent(componentChunkName).then(function (component) {
        var finalResult = {
          createdAt: new Date()
        };
        var pageResources;

        if (!component) {
          finalResult.status = "error";
        } else {
          finalResult.status = "success";

          if (result.notFound === true) {
            finalResult.notFound = true;
          }

          pageData = Object.assign(pageData, {
            webpackCompilationHash: allData[0] ? allData[0].webpackCompilationHash : ""
          });
          pageResources = toPageResources(pageData, component);
          finalResult.payload = pageResources;
          emitter.emit("onPostLoadPageResources", {
            page: pageResources,
            pageResources: pageResources
          });
        }

        _this2.pageDb.set(pagePath, finalResult); // undefined if final result is an error


        return pageResources;
      });
    }) // prefer duplication with then + catch over .finally to prevent problems in ie11 + firefox
    .then(function (response) {
      _this2.inFlightDb["delete"](pagePath);

      return response;
    })["catch"](function (err) {
      _this2.inFlightDb["delete"](pagePath);

      throw err;
    });
    this.inFlightDb.set(pagePath, inFlight);
    return inFlight;
  } // returns undefined if loading page ran into errors
  ;

  _proto.loadPageSync = function loadPageSync(rawPath) {
    var pagePath = findPath(rawPath);

    if (this.pageDb.has(pagePath)) {
      return this.pageDb.get(pagePath).payload;
    }

    return undefined;
  };

  _proto.shouldPrefetch = function shouldPrefetch(pagePath) {
    // Skip prefetching if we know user is on slow or constrained connection
    if (!doesConnectionSupportPrefetch()) {
      return false;
    } // Check if the page exists.


    if (this.pageDb.has(pagePath)) {
      return false;
    }

    return true;
  };

  _proto.prefetch = function prefetch(pagePath) {
    var _this3 = this;

    if (!this.shouldPrefetch(pagePath)) {
      return false;
    } // Tell plugins with custom prefetching logic that they should start
    // prefetching this path.


    if (!this.prefetchTriggered.has(pagePath)) {
      this.apiRunner("onPrefetchPathname", {
        pathname: pagePath
      });
      this.prefetchTriggered.add(pagePath);
    } // If a plugin has disabled core prefetching, stop now.


    if (this.prefetchDisabled) {
      return false;
    }

    var realPath = findPath(pagePath); // Todo make doPrefetch logic cacheable
    // eslint-disable-next-line consistent-return

    this.doPrefetch(realPath).then(function () {
      if (!_this3.prefetchCompleted.has(pagePath)) {
        _this3.apiRunner("onPostPrefetchPathname", {
          pathname: pagePath
        });

        _this3.prefetchCompleted.add(pagePath);
      }
    });
    return true;
  };

  _proto.doPrefetch = function doPrefetch(pagePath) {
    throw new Error("doPrefetch not implemented");
  };

  _proto.hovering = function hovering(rawPath) {
    this.loadPage(rawPath);
  };

  _proto.getResourceURLsForPathname = function getResourceURLsForPathname(rawPath) {
    var pagePath = findPath(rawPath);
    var page = this.pageDataDb.get(pagePath);

    if (page) {
      var pageResources = toPageResources(page.payload);
      return [].concat(_toConsumableArray(createComponentUrls(pageResources.page.componentChunkName)), [createPageDataUrl(pagePath)]);
    } else {
      return null;
    }
  };

  _proto.isPageNotFound = function isPageNotFound(rawPath) {
    var pagePath = findPath(rawPath);
    var page = this.pageDb.get(pagePath);
    return page && page.notFound === true;
  };

  _proto.loadAppData = function loadAppData(retries) {
    var _this4 = this;

    if (retries === void 0) {
      retries = 0;
    }

    return doFetch(__PATH_PREFIX__ + "/page-data/app-data.json").then(function (req) {
      var status = req.status,
          responseText = req.responseText;
      var appData;

      if (status !== 200 && retries < 3) {
        // Retry 3 times incase of failures
        return _this4.loadAppData(retries + 1);
      } // Handle 200


      if (status === 200) {
        try {
          var jsonPayload = JSON.parse(responseText);

          if (jsonPayload.webpackCompilationHash === undefined) {
            throw new Error("not a valid app-data response");
          }

          appData = jsonPayload;
        } catch (err) {// continue regardless of error
        }
      }

      return appData;
    });
  };

  return BaseLoader;
}();

var createComponentUrls = function createComponentUrls(componentChunkName) {
  return window.___chunkMapping[componentChunkName].map(function (chunk) {
    return __PATH_PREFIX__ + chunk;
  });
};

export var ProdLoader =
/*#__PURE__*/
function (_BaseLoader) {
  _inheritsLoose(ProdLoader, _BaseLoader);

  function ProdLoader(asyncRequires, matchPaths) {
    var loadComponent = function loadComponent(chunkName) {
      return asyncRequires.components[chunkName]().then(preferDefault);
    };

    return _BaseLoader.call(this, loadComponent, matchPaths) || this;
  }

  var _proto2 = ProdLoader.prototype;

  _proto2.doPrefetch = function doPrefetch(pagePath) {
    var _this5 = this;

    var pageDataUrl = createPageDataUrl(pagePath);
    return prefetchHelper(pageDataUrl).then(function () {
      return (// This was just prefetched, so will return a response from
        // the cache instead of making another request to the server
        _this5.loadPageDataJson(pagePath)
      );
    }).then(function (result) {
      if (result.status !== "success") {
        return Promise.resolve();
      }

      var pageData = result.payload;
      var chunkName = pageData.componentChunkName;
      var componentUrls = createComponentUrls(chunkName);
      return Promise.all(componentUrls.map(prefetchHelper)).then(function () {
        return pageData;
      });
    });
  };

  return ProdLoader;
}(BaseLoader);
var instance;
export var setLoader = function setLoader(_loader) {
  instance = _loader;
};
export var publicLoader = {
  // Deprecated methods. As far as we're aware, these are only used by
  // core gatsby and the offline plugin, however there's a very small
  // chance they're called by others.
  getResourcesForPathname: function getResourcesForPathname(rawPath) {
    console.warn("Warning: getResourcesForPathname is deprecated. Use loadPage instead");
    return instance.i.loadPage(rawPath);
  },
  getResourcesForPathnameSync: function getResourcesForPathnameSync(rawPath) {
    console.warn("Warning: getResourcesForPathnameSync is deprecated. Use loadPageSync instead");
    return instance.i.loadPageSync(rawPath);
  },
  enqueue: function enqueue(rawPath) {
    return instance.prefetch(rawPath);
  },
  // Real methods
  getResourceURLsForPathname: function getResourceURLsForPathname(rawPath) {
    return instance.getResourceURLsForPathname(rawPath);
  },
  loadPage: function loadPage(rawPath) {
    return instance.loadPage(rawPath);
  },
  loadPageSync: function loadPageSync(rawPath) {
    return instance.loadPageSync(rawPath);
  },
  prefetch: function prefetch(rawPath) {
    return instance.prefetch(rawPath);
  },
  isPageNotFound: function isPageNotFound(rawPath) {
    return instance.isPageNotFound(rawPath);
  },
  hovering: function hovering(rawPath) {
    return instance.hovering(rawPath);
  },
  loadAppData: function loadAppData() {
    return instance.loadAppData();
  }
};
export default publicLoader;